module.exports = "/images/trialproofer-app-image@2x.png?08b761d85f7a737e21e1abb11a9530b1";